"use strict";
/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentFeature = exports.AssessmentScoreType = exports.AssessmentResourceAction = exports.MetadataValueType = exports.OptionalAssessmentMetadataKey = exports.AssessmentResponseTypes = exports.CustomerCloudMaturity = exports.AssessmentStatus = void 0;
var AssessmentStatus;
(function (AssessmentStatus) {
    AssessmentStatus["IN_PROGRESS"] = "IN_PROGRESS";
    AssessmentStatus["COMPLETED"] = "COMPLETED";
})(AssessmentStatus = exports.AssessmentStatus || (exports.AssessmentStatus = {}));
var CustomerCloudMaturity;
(function (CustomerCloudMaturity) {
    CustomerCloudMaturity["LOW"] = "LOW";
    CustomerCloudMaturity["HIGH"] = "HIGH";
})(CustomerCloudMaturity = exports.CustomerCloudMaturity || (exports.CustomerCloudMaturity = {}));
var AssessmentResponseTypes;
(function (AssessmentResponseTypes) {
    AssessmentResponseTypes["YES_NO"] = "YES_NO";
    AssessmentResponseTypes["TEXT"] = "TEXT";
    AssessmentResponseTypes["RATING"] = "RATING";
    AssessmentResponseTypes["NUMBER"] = "NUMBER";
    AssessmentResponseTypes["SINGLE_SELECTION"] = "SINGLE_SELECTION";
    AssessmentResponseTypes["MULTI_SELECTION"] = "MULTI_SELECTION";
    AssessmentResponseTypes["DATE_VALUE"] = "DATE_VALUE";
})(AssessmentResponseTypes = exports.AssessmentResponseTypes || (exports.AssessmentResponseTypes = {}));
var OptionalAssessmentMetadataKey;
(function (OptionalAssessmentMetadataKey) {
    OptionalAssessmentMetadataKey["opportunityId"] = "opportunityId";
    OptionalAssessmentMetadataKey["mapProgramEngagementId"] = "mapProgramEngagementId";
    OptionalAssessmentMetadataKey["internalContact"] = "internalContact";
    OptionalAssessmentMetadataKey["workshopDate"] = "workshopDate";
    OptionalAssessmentMetadataKey["readoutDate"] = "readoutDate";
})(OptionalAssessmentMetadataKey = exports.OptionalAssessmentMetadataKey || (exports.OptionalAssessmentMetadataKey = {}));
var MetadataValueType;
(function (MetadataValueType) {
    MetadataValueType["text"] = "text";
    MetadataValueType["dateValue"] = "dateValue";
    MetadataValueType["yesno"] = "yesno";
    MetadataValueType["singleSelection"] = "singleSelection";
})(MetadataValueType = exports.MetadataValueType || (exports.MetadataValueType = {}));
var AssessmentResourceAction;
(function (AssessmentResourceAction) {
    AssessmentResourceAction["FULL"] = "FULL";
    AssessmentResourceAction["UPDATE"] = "UPDATE";
    AssessmentResourceAction["VIEW"] = "VIEW";
})(AssessmentResourceAction = exports.AssessmentResourceAction || (exports.AssessmentResourceAction = {}));
var AssessmentScoreType;
(function (AssessmentScoreType) {
    AssessmentScoreType["AMS_FIT_SCORE"] = "AMS_FIT_SCORE";
})(AssessmentScoreType = exports.AssessmentScoreType || (exports.AssessmentScoreType = {}));
var AssessmentFeature;
(function (AssessmentFeature) {
    AssessmentFeature["ADMIN_CUSTOMER_ACCOUNTS"] = "ADMIN_CUSTOMER_ACCOUNTS";
    AssessmentFeature["ADMIN_OVERVIEW"] = "ADMIN_OVERVIEW";
    AssessmentFeature["ADMIN_RECOMMENDED_ACTIONS"] = "ADMIN_RECOMMENDED_ACTIONS";
    AssessmentFeature["ADMIN_ORGANIZATION_CUSTOMIZATION"] = "ADMIN_ORGANIZATION_CUSTOMIZATION";
    AssessmentFeature["ADMIN_TEMPLATE_MANAGEMENT"] = "ADMIN_TEMPLATE_MANAGEMENT";
    AssessmentFeature["ADMIN_CAS2_ENABLED"] = "ADMIN_CAS2_ENABLED";
    AssessmentFeature["ADMIN_RS_ENABLED"] = "ADMIN_RS_ENABLED";
})(AssessmentFeature = exports.AssessmentFeature || (exports.AssessmentFeature = {}));
